/** Value of scheduleGenerationSettings.needsContraintInputMode that enables the per-key needs UI. */
export const NEEDS_INPUT_MODE_V2 = "v2";

/** dicOfNeeds keys edited by the new needs UI, in display order (one row block per key). */
export const NEED_KEYS = ["default", "holiday"] as const;

export const NEED_KEY_LABELS: Record<string, string> = {
    default: "Régulier",
    holiday: "Férié",
};
